import { Directive } from '@angular/core';

@Directive({
    selector: 'a[wdxTabLink]',
    standalone: false,
    host: { class: 'nav-link' },
})
export class WdxTabLinkDirective {}
